// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
Vue.config.productionTip = false

// rem响应式
require("./assets/js/flexible")

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper)

// 兼容axios+es6语法
import "babel-polyfill"
import promise from 'es6-promise'
promise.polyfill()

// axios
import axios from "axios"
Vue.prototype.$axios = axios;
import {
	post,
	fetch,
	Del
} from './request/http.js'
// //定义全局变量
Vue.prototype.$post = post
Vue.prototype.$fetch = fetch
Vue.prototype.$Del = Del

// ElementUI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

// mobile-滑动
import VueTouch from "vue-touch"
Vue.use(VueTouch, {
	name: "v-touch"
})
VueTouch.config.swipe = {
	threshold: 200
}

// 图片查看器
// import 'viewerjs/dist/viewer.css'
// import VueViewer from 'v-viewer'
// Vue.use(VueViewer)

// 路由守卫
import {
	getCookie,
	clearCookie
} from './assets/js/GetCookie'
router.beforeEach((to, from, next) => {
	// 所有页面访问记录 如果在本项目里来回跳转传值为''
	let url = `${Const_Api_Root}/#${to.fullPath}`,
		prevUrl = document.referrer,
		referrer = prevUrl.indexOf(Const_Api_Root) === -1 ? prevUrl : ''
	post('/api/PageAccessRecord', {
			url,
			referrer
		})
		.then((res) => {

		}).catch((err) => {
			throw err;
		});

	// 设置微信cookie
	let wx = getCookie('wx');
	// let flag = sessionStorage.getItem('flag');
	if (wx) {
		post('/Login/SignInFromWeiXin')
			.then(function(response) {
				// sessionStorage.setItem('flag','foo');
				clearCookie()
				next();
			}).catch(function(error) {
				// console.log(error);
			});
	} else {
		next();
	}
})

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	components: {
		App
	},
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js